(function ($) {


  let videosLoaded = false;

  function loadSliderVideos() {
    if (videosLoaded) return;
    videosLoaded = true;

    console.log("🔥 Loading slider videos");

    $('.slick-video-slider video').each(function () {
      this.preload = "auto";
      this.load();
    });
  }

  // 👉 user interaction = instant load
  ['scroll', 'click', 'touchstart'].forEach(event => {
    window.addEventListener(event, loadSliderVideos, { once: true });
  });

  // 👉 fallback (10s delay)
  setTimeout(loadSliderVideos, 10000);

  /* ------------------------------------------------------------
    WAIT FOR SLICK (Shopify-safe)
  ------------------------------------------------------------ */
  function waitForSlick(callback, tries = 0) {
    if (typeof $ !== 'undefined' && typeof $.fn.slick === 'function') {
      callback();
    } else if (tries < 40) {
      setTimeout(() => waitForSlick(callback, tries + 1), 50);
    } else {
      console.warn('Slick failed to load');
    }
  }

  /* ------------------------------------------------------------
    SLIDER INIT
  ------------------------------------------------------------ */
  function initWellnessVideoSlider($scope) {
    $scope = $scope || $(document);

    $scope.find('.slick-video-slider').each(function () {
      const $slider = $(this);

      // Prevent double init
      if ($slider.hasClass('slick-initialized')) return;
      if (typeof $.fn.slick !== 'function') return;

      const $container = $slider.closest('.wellness-video-slider');
      const $leftArrow = $container.find('.video-left-arrow');
      const $rightArrow = $container.find('.video-right-arrow');
      const $progressFill = $container.find('.video-fs-fill');

      /* --------------------------------------------------------
        SLIDE CHANGE HANDLER
      -------------------------------------------------------- */
      function handleSlideChange(event, slick) {
        if (!slick) return;

        const currentIndex = slick.currentSlide;
        const total = slick.slideCount;

        /* --------------------
           POSITION CLASSES
        -------------------- */
        $slider.find('.video-slide')
          .removeClass('pos--2 pos--1 pos-0 pos-1 pos-2');

        $slider.find('.video-slide').each(function () {
          const slideIndex = $(this).data('slick-index');
          const diff = slideIndex - currentIndex;

          if (diff === -2) $(this).addClass('pos--2');
          if (diff === -1) $(this).addClass('pos--1');
          if (diff === 0)  $(this).addClass('pos-0');
          if (diff === 1)  $(this).addClass('pos-1');
          if (diff === 2)  $(this).addClass('pos-2');
        });

         /* --------------------
           VIDEO RESET
        -------------------- */
       
        [
          ".video-slide.pos--2 video",
          ".video-slide.pos--1 video",
          ".video-slide.pos-2 video",
          ".video-slide.pos-1 video"
        ].forEach(selector => {
          $(selector).each(function () {
            this.pause();
            this.currentTime = 0;
          });
        });

        $slider.find('iframe').each(function () {
          this.contentWindow?.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
        });

        const $current = $slider.find('.slick-current');

        // HTML5 video
        const video = $current.find('video').get(0);
        //if (video) video.play();


        /* --------------------
           PROGRESS BAR
        -------------------- */
        const realIndex = ((currentIndex % total) + total) % total;
        const progress = ((realIndex + 1) / total) * 100;
        $progressFill.css('width', progress + '%');
      }

      /* --------------------------------------------------------
        EVENTS
      -------------------------------------------------------- */
      $slider.on('init afterChange', handleSlideChange);

      /* --------------------------------------------------------
        INIT SLICK
      -------------------------------------------------------- */
      $slider.slick({
        slidesToShow: 5,
        centerMode: true,
        arrows: false,
        infinite: true,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3 } },
          { breakpoint: 768,  settings: { slidesToShow: 1 } }
        ]
      });

      // click slide to center it
      $slider.on('click', '.slick-slide', function (e) {
        console.log("slider_clicked")
        //e.stopPropagation(); 
        var index = $(this).data("slick-index");
        $slider.slick('slickGoTo', index);
      });


      /* --------------------------------------------------------
        CUSTOM ARROWS
      -------------------------------------------------------- */
      $leftArrow.off('click').on('click', function () {
        $slider.slick('slickPrev');
      });

      $rightArrow.off('click').on('click', function () {
        $slider.slick('slickNext');
      });
    });
  }

  /* ------------------------------------------------------------
    INITIAL LOAD
  ------------------------------------------------------------ */
  $(document).ready(function () {
    waitForSlick(() => {
      initWellnessVideoSlider();
    });
  }); 

  $(document).on('click', '.video-toggle-btn', function() {
    console.log("video-toggle-btn clicked")
    const $container = $(this).closest('.video-player-wrapper');
    const video = $container.find('video')[0];
    const $btn = $(this);

    if (video.paused) {
      
       $('video').each(function() {
        this.pause();
        this.currentTime = 0;

        const $wrapper = $(this).closest('.video-player-wrapper');
        const $pauseBtn = $wrapper.find('.video-toggle-btn');

        $pauseBtn
          .removeClass('video-paused')
          .addClass('video-play')
          .text('▶');
      });

      video.play();
  
      $btn.removeClass("video-play");
      $btn.addClass("video-paused");
      $btn.text('❚❚');

    } else {
      video.pause();

      $btn.addClass("video-play");
      $btn.removeClass("video-paused");
      $btn.text('▶');
    }
  });


  $(window).on('load', function() {
    $('video').each(function() {
      this.pause();
      this.currentTime = 0; // optional — reset to start
    });
  });

  /* ------------------------------------------------------------
    SHOPIFY THEME EDITOR SUPPORT
  ------------------------------------------------------------ */
  $(document).on('shopify:section:load', function (e) {
    waitForSlick(() => {
      initWellnessVideoSlider($(e.target));
    });
  });

})(jQuery);



